/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, inserted: NonNullable<unknown>, skipped: NonNullable<unknown> }} Event_Group_Sync_Success_ToastInputs */

const en_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const fr_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const de_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const it_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const ru_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const es_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const zh_cn2_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const ja_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const hi_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

const pt_pt2_event_group_sync_success_toast = /** @type {(inputs: Event_Group_Sync_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes synced successfully. ${i?.matched} updated, ${i?.inserted} inserted, ${i?.skipped} skipped.`)
};

/**
* | output |
* | --- |
* | "Changes synced successfully. {matched} updated, {inserted} inserted, {skipped} skipped." |
*
* @param {Event_Group_Sync_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_success_toast = /** @type {((inputs: Event_Group_Sync_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_sync_success_toast(inputs)
	if (locale === "de") return de_event_group_sync_success_toast(inputs)
	if (locale === "it") return it_event_group_sync_success_toast(inputs)
	if (locale === "ru") return ru_event_group_sync_success_toast(inputs)
	if (locale === "es") return es_event_group_sync_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_sync_success_toast(inputs)
	if (locale === "ja") return ja_event_group_sync_success_toast(inputs)
	if (locale === "hi") return hi_event_group_sync_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_sync_success_toast(inputs)
	return en_event_group_sync_success_toast(inputs)
});